module.exports = __webpack_public_path__ + "img/three_high_doc_qrcode.780afb36.png";